import { useState, useEffect } from 'react';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import * as organisationService from '@frolight/services/api/organisationService';

const useOrganisationGatewayData = (gatewayData) => {

  const [ loading, setLoading ] = useState(true);
  const [ data, setData ] = useState(null);
  const [ error, setError ] = useState(null);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();

  useEffect(() => {
    let mounted = true;

    const getOrganisationDataForGatewayAbortController = new AbortController();
    const runEffect = async () => {
      if (mounted) setLoading(true);

      try {
        if (!gatewayData.organisationId) {
          setData(null);
        } else {
          const organisation = await authenticatedAPIServiceCall(
            organisationService.getOrganisation,
            {
              abortController: getOrganisationDataForGatewayAbortController,
              opts: {
                organisationId: gatewayData.organisationId
              }
            }
          );
          if (organisation) {
            if (mounted) setData(organisation.data);
          } else {
            if (mounted) setError(new Error(`Error getting organisation "${gatewayData.organisationId}" for gateway "${gatewayId}"`));
          }
        }
      } catch (err) {
        if (err.name !== 'AbortError') {
          if (mounted) setError(err.message);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (gatewayData) {
      runEffect();
    }

    return () => {
      mounted = false;
      getOrganisationDataForGatewayAbortController.abort();
    }

  }, [ gatewayData ]);

  return { loading, error, data };
};

export default useOrganisationGatewayData;